import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

const useStyles = createUseStyles((theme) => {
  const {
    assetsBaseUri,
    assetsFontPath,
    assetsFontName,
    assetsFontVersion,
    fontFamily,
    fontSize,
    fontWeight,
  } = theme;

  const fontPath = `${assetsBaseUri}${assetsFontPath}`;
  const fontFaces = Object.keys(fontWeight).map((name) => {
    // we need this because the font file names are all National2-<Weight>.2.ext
    const upperCaseName = `${name[0].toUpperCase()}${name.substring(1)}`;
    const weight = fontWeight[name];
    return {
      fontFamily: assetsFontName,
      fontWeight: weight,
      fontDisplay: 'swap',
      src: `url(${fontPath}-${upperCaseName}.${assetsFontVersion}.woff2) format('woff2')`,
      fallbacks: [
        {
          src: `url(${fontPath}-${upperCaseName}.${assetsFontVersion}.woff) format('woff')`,
        },
        {
          src: `url(${fontPath}-${upperCaseName}.${assetsFontVersion}.eot#iefix) format('embedded-opentype')`,
        },
      ],
    };
  });

  return {
    '@font-face': fontFaces,
    '@global': {
      "[class*='wrench'], [class*='wrench']::before, [class*='wrench']::after": {
        fontFamily: fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        fontSize: fontSize.body,
        boxSizing: 'border-box',
        padding: 0,
        margin: 0,
        listStyle: 'none',
      },
    },
  };
});

const GlobalStyles = () => {
  const theme = useTheme();
  useStyles({ theme });
  return <></>;
};

export default GlobalStyles;
